import React, { useContext, useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import loanImg from "../src/assest/ShubhPaisa.svg";
import banner from "../src/assest/ban1.png";
import EMICalculator from "./EMICalculator";
import { PersonalDetailsModal } from "./Modal";
import { GlobalContext } from "./Context/GlobalState";
import swal from "sweetalert";
import loaderGif from "../src/assest/Untitled design (5).gif";

const Main = () => {
  const timerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(60);
  const { setUserData } = useContext(GlobalContext);
  const [otpVerified, setOtpVerified] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    c1: false,
    c2: false,
    c3: false,
  });
  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setCheckboxes((prev) => ({ ...prev, [id]: checked }));
  };
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos) => {
      setLat(pos.coords.latitude.toString());
      setLong(pos.coords.longitude.toString());
    });
  }, []);
  const sendOtp = async () => {
    if (mobile.length !== 10) {
      return;
    }

    setLoading(true);

    try {
      const bodyData = {
        mobile: mobile,
        otp: "",
        latitude: lat,
        longitude: long,
        step: "1",
        device: "web",
        source: "landing-page",
      };

      const response = await fetch(
        "https://api.shubhpaisa.com/api/ShubhPaisa/SendOtp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyData),
        }
      );

      const data = await response.json();

      if (data.status === "0" && data.data?.[0]?.result === "Y") {
        setStep(2);
        setOtpSent(true);
        setTimer(60);
        if (timerRef.current) clearInterval(timerRef.current);

        timerRef.current = setInterval(() => {
          setTimer((prev) => {
            if (prev === 1) {
              clearInterval(timerRef.current);
              timerRef.current = null;
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        console.log("OTP send failed:", data);
      }
    } catch (err) {
      console.log("Network error:", err);
    }

    setLoading(false);
  };
  const verifyOtp = async () => {
    if (otp.length !== 6) {
      swal("Invalid OTP", "Enter a valid 6-digit OTP", "warning");
      return;
    }

    setLoading(true);

    try {
      const bodyData = {
        mobile: mobile,
        otp: otp,
        latitude: lat,
        longitude: long,
        step: "2",
        device: "web",
        source: "landing-page",
      };

      const response = await fetch(
        "https://api.shubhpaisa.com/api/ShubhPaisa/SendOtp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyData),
        }
      );

      const data = await response.json();

      if (
        data.status === "0" &&
        data.data &&
        data.data.length > 0 &&
        data.data[0].result === "Y"
      ) {
        const token = data.data[0].token;
        const userid = data.data[0].userid;

        setUserData({
          token: token,
          userid: userid,
        });

        setOtpVerified(true);
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
        setTimer(0);
        setShowModal(true);

        // swal("Success", "OTP Verified Successfully!", "success");
      } else {
        swal("Failed", data.msg || "OTP verification failed", "error");
      }
    } catch (err) {
      swal("Error", "Network error!", "error");
    }

    setLoading(false);
  };
  const handleApply = () => {
    const allChecked = Object.values(checkboxes).every((v) => v);
    if (!allChecked) {
      swal("Incomplete", "Please check all boxes before applying!", "warning");
      return;
    }
    verifyOtp();
  };
  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return (
    <>
 {loading && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      // background: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      backdropFilter: "blur(1px)",
    }}
  >
    <img
      src={loaderGif}
      alt="loading"
      style={{  width:"20vw"}}
    />
  </div>
)}

      <div
        style={{
          background: "linear-gradient(135deg, #0e9bff, #3ac8ff)",
          padding: "13px 0",
          color: "white",
          textAlign: "center",
          fontWeight: "600",
          letterSpacing: ".5px",
        }}
      >
        <span style={{ fontSize: "1.2rem" }}>
          ⚡ Get Instant Loan Approval with us — Apply Now!
        </span>
      </div>

      <div className="d-flex justify-content-center mb-4">
        <div className="col-md-10 col-12 mt-3">
          <div>
            <img
              src={loanImg}
              alt="logo"
              className="mb-4"
              style={{ width: "16rem" }}
            />
          </div>

          <div className="row align-items-center mt-2">
            <div className="col-md-6">
              <h1 className=" mb-2">Get Instant Loan up to ₹5 lakhs</h1>
              <p className="text-muted mb-4">
                Get instant Personal Loan approval with minimal documents. Fast,
                secure and hassle-free loan processing with ShubhPaisa.
              </p>
              <label className="fw-medium mb-1">Enter mobile number</label>

              <div
                className="position-relative mb-2"
                style={{ maxWidth: "340px" }}
              >
                <span
                  style={{
                    position: "absolute",
                    left: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontWeight: "600",
                  }}
                >
                  +91
                </span>

                <input
                  type="text"
                  className="form-control bg-light"
                  maxLength="10"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder="Enter mobile number"
                  style={{
                    paddingLeft: "55px",
                    paddingRight: "120px",
                    height: "50px",
                    borderRadius: "10px",
                  }}
                />

                {mobile.length === 10 && (
                  <button
                    onClick={() => !loading && !otpSent && sendOtp()}
                    className="btn btn-primary"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      height: "36px",
                      padding: "0 12px",
                      fontSize: "0.8rem",
                      borderRadius: "8px",
                    }}
                    disabled={otpSent}
                  >
                    {loading ? "Sending..." : otpSent ? "Sent" : "Send OTP"}
                  </button>
                )}
              </div>

              {step === 2 && (
                <>
                  <label className="fw-medium mb-1">Enter OTP</label>

                  <div
                    className="position-relative mb-2"
                    style={{ maxWidth: "340px" }}
                  >
                    <input
                      type="text"
                      className="form-control bg-light"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      placeholder="Enter OTP"
                      style={{
                        paddingRight: "120px",
                        height: "50px",
                        borderRadius: "10px",
                      }}
                    />

                    <span
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "0.85rem",
                        color: timer > 0 ? "#555" : "#007bff",
                        cursor: timer === 0 ? "pointer" : "default",
                        fontWeight: "600",
                      }}
                      onClick={() => {
                        if (timer === 0) {
                          setOtpSent(false);
                          sendOtp();
                        }
                      }}
                    >
                      {timer > 0 ? `${timer}s` : "Resend"}
                    </span>
                  </div>
                </>
              )}

              <div className="mb-3">
                <div className="form-check mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="c1"
                    checked={checkboxes.c1}
                    onChange={handleCheckboxChange}
                  />
                  <label
                    className="form-check-label"
                    style={{ fontSize: ".9rem" }}
                  >
                    I confirm that my annual household income is above ₹3,00,000
                    and I am eligible for &nbsp;
                    <a href="/" className="text-primary fw-semibold">
                      ShubhPaisa Personal Loan
                    </a>
                  </label>
                </div>

                <div className="form-check mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="c2"
                    checked={checkboxes.c2}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <label
                    className="form-check-label"
                    style={{ fontSize: ".9rem" }}
                  >
                    By continuing, I agree to the
                    <a href="/" className="text-primary fw-semibold">
                      Terms & Conditions
                    </a>
                    ,
                    <a href="/" className="text-primary fw-semibold">
                      Privacy Policy
                    </a>
                    and understand ShubhPaisa’s loan risk grading.
                  </label>
                </div>

                <div className="form-check mb-4">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="c3"
                    checked={checkboxes.c3}
                    onChange={handleCheckboxChange}
                  />{" "}
                  <label
                    className="form-check-label"
                    style={{ fontSize: ".9rem" }}
                  >
                    I provide my Aadhaar consent and authorize ShubhPaisa to
                    retrieve, verify and validate my KYC, PAN and credit score.
                  </label>
                </div>
              </div>
              <button
                className="btn btn-info px-5 py-2 fw-semibold mb-3"
                onClick={handleApply}
                disabled={otpVerified}
              >
                {otpVerified ? "Verified" : "APPLY NOW"}
              </button>
            </div>

            <div className="col-md-6 d-flex justify-content-end">
              <img
                src={banner}
                alt="loan"
                style={{
                  width: "100%",
                  maxWidth: "70rem",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>

          <EMICalculator />
          <Fotter />
        </div>
      </div>

      <PersonalDetailsModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </>
  );
};
const features = [
  {
    icon: "%",
    title: "Low Interest Rates",
    desc: "ShubhPaisa offers attractive personal loan rates starting from just 12.65%",
    color: "#e3f2fd",
  },
  {
    icon: "₹",
    title: "Instant Money Transfer",
    desc: "Loan amount gets credited to your bank within minutes",
    color: "#f0f4f8",
  },
  {
    icon: "⏱",
    title: "Fast Approval",
    desc: "Digital KYC + Quick loan verification",
    color: "#e8f5e9",
  },
  {
    icon: "0",
    title: "No Prepayment Charges*",
    desc: "Repay early anytime without extra fees",
    color: "#fffde7",
  },
  {
    icon: "⭐",
    title: "High Approval Chances",
    desc: "90% approval rate for eligible applicants",
    color: "#f3e5f5",
  },
  {
    icon: "🔒",
    title: "Secure Document Upload",
    desc: "100% safe digital application process",
    color: "#eceff1",
  },
];

const FeatureCard = ({ icon, title, desc, color }) => (
  <div className="col-md-4 col-6 mb-4  mt-2">
    <div
      style={{
        background: `linear-gradient(135deg, ${color}, #ffffff)`,
        borderRadius: "18px",
        padding: "20px",
        boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
        cursor: "pointer",
      }}
      className="h-100 hover-card"
    >
      <div
        style={{
          width: "70px",
          height: "70px",
          borderRadius: "50%",
          background: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "28px",
          fontWeight: "600",
          margin: "auto",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        {icon}
      </div>

      <h6 className="fw-bold mt-3">{title}</h6>
      <small>{desc}</small>
    </div>
  </div>
);

const Fotter = () => {
  return (
    <>
      <div className="container mt-3" style={{}}>
        <div className="row text-center">
          {features.map((item, index) => (
            <FeatureCard key={index} {...item} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Main;
